module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.2-209.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.1-rc.2.md
// module id = 653
// module chunks = 349